import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { T } from "services/lang/LanguageService";

interface EditColumnProps {
  selectedColumnOptions: ColumnOptions;
  setSelectedColumnOptions: (columnOptions: ColumnOptions) => void;
  isEditColumnDialogVisible: boolean;
  setEditColumnDialogVisible: (isEditingColumnDialogVisible: boolean) => void;
  removeColumn: () => void;
}

export interface ColumnOptions {
  id: string;
  title: string;
  columnHeaderVisibility: boolean;
  columnVisibility: boolean;
}

const defaultColumnOptions: ColumnOptions = {
  id: uuidv4(),
  title: "",
  columnHeaderVisibility: true,
  columnVisibility: true,
};

const EditColumn = ({
  selectedColumnOptions,
  setSelectedColumnOptions,
  isEditColumnDialogVisible,
  setEditColumnDialogVisible,
  removeColumn,
}: EditColumnProps) => {
  const [currentConfig, setCurrentConfig] = useState<ColumnOptions>(
    selectedColumnOptions ?? defaultColumnOptions
  );
  const handleSave = () => {
    setEditColumnDialogVisible(false);
    setSelectedColumnOptions(currentConfig);
  };

  const handleRemoveColumn = () => {
    confirmDialog({
      message: T("confirm-dialog.are-you-sure-you-want-to-remove-this-column"),
      header: T("confirm-dialog.confirmation"),
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      acceptLabel: T("action.remove"),
      rejectLabel: T("word.no"),
      accept: () => {
        removeColumn();
        setEditColumnDialogVisible(false);
      },
    });
  };

  const editColumnFooter = () => {
    return (
      <div className="flex flex-row justify-content-between mt-4">
        <Button
          label={T("action.remove-column")}
          className="p-button-danger"
          icon="pi pi-times"
          onClick={handleRemoveColumn}
        />
        <div className="flex gap-2">
          <Button label={T("action.cancel")} onClick={() => setEditColumnDialogVisible(false)} />
          <Button label={T("action.save")} className="p-button-success" onClick={handleSave} />
        </div>
      </div>
    );
  };
  return (
    <Dialog
      header={T("action.edit-column")}
      visible={isEditColumnDialogVisible}
      footer={editColumnFooter}
      style={{ width: "400px" }}
      onHide={() => setEditColumnDialogVisible(false)}
    >
      <div className="p-fluid">
        <label htmlFor="columnTitle">{T("header.column-title")}</label>
        <InputText
          id="columnTitle"
          value={currentConfig.title ?? ""}
          onChange={e => setCurrentConfig({ ...currentConfig, title: e.target.value })}
        />

        <div className="flex align-items-center gap-2 mt-3">
          <label htmlFor="columnHeaderVisibility">{T("label.column-header-visibility")}</label>
          <InputSwitch
            id="columnHeaderVisibility"
            checked={currentConfig.columnHeaderVisibility ?? false}
            onChange={e => setCurrentConfig({ ...currentConfig, columnHeaderVisibility: e.value })}
          />
        </div>

        <div className="flex align-items-center gap-2 mt-3">
          <label htmlFor="columnVisibility">{T("label.column-visibility")}</label>
          <InputSwitch
            id="columnVisibility"
            checked={currentConfig.columnVisibility ?? false}
            onChange={e => setCurrentConfig({ ...currentConfig, columnVisibility: e.value })}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default EditColumn;
